import { useMemo } from 'react';
import { useSubdomain } from './useSubdomain';
import useAuth from 'Modules/firebase/use-auth';
import useNotification from '@/contexts/NotificationContext/hooks/useNotification';
import { useHandleUserSessionData } from '@/operator/hooks/useHandleUserSessionData';
import { appRoutes } from "app/routes/constants";
import { getOrgPathName } from "@/operator/utils/env/urlStrings";

function useAuthLogout(): () => void {
    const { showNotification } = useNotification();
    const { subdomain } = useSubdomain();
    const { logout } = useAuth();
    const { removeSessionData } = useHandleUserSessionData();

    const logoutFn = useMemo(() => {
        return () => {
            localStorage.removeItem(process.env.OPERATOR_TOKEN_KEY);
            removeSessionData();
            const orgPathName = getOrgPathName();
            logout({
                logoutParams: {
                    returnTo: `${window.location.origin.replace(subdomain, 'app')}/${appRoutes.LOGGED_OUT}`,
                    navigateTo: `${orgPathName}/${appRoutes.LOGGED_OUT}`
                },
            })
                .then(() => {
                    showNotification({
                        message: 'You have been logged out',
                        severity: 'success',
                    });
                })
                .catch((_err) => {
                    showNotification({
                        message: 'Could not perform logout',
                        severity: 'error',
                    });
                });
        };
    }, [logout, subdomain]);

    return logoutFn;
}

export default useAuthLogout;
